import { Box, Button } from "grommet";

interface ToggleButtonGroupProps {
  options: [string, string];
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

const toggleButtonBaseStyle = {
  color: "#000",
  padding: "5px 9px",
  border: "1px solid var(--warm-gray-400)",
  alignItems: "center",
  justifyContent: "center"
};

const ToggleButtonGroup = ({ options, value, setValue }: ToggleButtonGroupProps) => (
  <Box direction="row">
    <Box flex>
      <Button
        label={options[0]}
        onClick={() => setValue(options[0])}
        active={value === options[0]}
        style={{
          ...toggleButtonBaseStyle,
          borderRight: "0",
          borderTopRightRadius: "0",
          borderBottomRightRadius: "0",
          fontWeight: value === options[0] ? 700 : "normal"
        }}
      />
    </Box>
    <Box flex>
      <Button
        label={options[1]}
        onClick={() => setValue(options[1])}
        active={value === options[1]}
        style={{
          ...toggleButtonBaseStyle,
          borderTopLeftRadius: "0",
          borderBottomLeftRadius: "0",
          fontWeight: value === options[1] ? 700 : "normal"
        }}
      />
    </Box>
  </Box>
);

export default ToggleButtonGroup;
